export default __webpack_public_path__ + "static/media/a94b95d6-c02d-40c2-8579-15c27bc7ea8e.cf5c45b1.woff2";